import React from 'react';
import {CircularProgress} from '@mui/material';

import {StyledBox, StyledCircularProgress, TokenNumber, TokenNumberContainer} from './styles';
import {useCountdown} from '../../../hooks/useCountdown/index';
import {ProgressProps} from './types';

export function Progress({initialValueInSeconds, tokenNumber}: ProgressProps) {
	const {progressValue, isExpired} = useCountdown(initialValueInSeconds);

	return (
		<StyledBox>
			<CircularProgress
				variant="determinate"
				size={200}
				value={100}
				sx={{color: theme => theme.colors.gray['10Percent']}}
			/>
			{isExpired ? null : (
				<StyledCircularProgress variant="determinate" value={-progressValue} size={200} />
			)}

			<TokenNumberContainer>
				<TokenNumber color="primary">{isExpired ? '--- ---' : tokenNumber}</TokenNumber>
			</TokenNumberContainer>
		</StyledBox>
	);
}
